// import { useState } from "react";
// import { Link } from "react-router-dom";
// import classNames from "classnames";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import { Collapse, List } from "@mui/material";
// import "./side.css";
// import { RxDashboard } from "react-icons/rx";
// import { BiLogoPlayStore } from "react-icons/bi";
// import { MdProductionQuantityLimits } from "react-icons/md";
// import { LuSettings } from "react-icons/lu";
// import { BiSolidUserCircle } from "react-icons/bi";
// import { IoNotificationsCircleOutline } from "react-icons/io5";
// import { TbTruckDelivery, TbMapPinCode } from "react-icons/tb";
// import { Phone } from "@mui/icons-material";
// import StarBorderIcon from "@mui/icons-material/StarBorder";

// const Sidebar = () => {
//   const [open1, setOpen1] = useState(false);
//   const [open4, setOpen4] = useState(false);
//   const [open5, setOpen5] = useState(false);
//   const [open6, setOpen6] = useState(false);
//   const [open11, setOpen11] = useState(false);

//   const superuserId = localStorage.getItem("is_superuser");

//   const handleClick1 = () => {
//     setOpen1(!open1);
//   };
//   // const handleClick3 = () => {
//   //   setOpen3(!open3);
//   // };
//   const handleClick4 = () => {
//     setOpen4(!open4);
//   };
//   const handleClick6 = () => {
//     setOpen6(!open6);
//   };
//   // const handleClick7 = () => {
//   //   setOpen7(!open7);
//   // };
//   // const handleClick8 = () => {
//   //   setOpen8(!open8);
//   // };
//   // const handleClick9 = () => {
//   //   setOpen9(!open9);
//   // };
//   // const handleClick10 = () => {
//   //   setOpen10(!open10);
//   // };
//   const handleClick11 = () => {
//     setOpen11(!open11);
//   };

//   // const handleClick12 = () => {
//   //   setOpen12(!open12);
//   // };

//   return (
//     <>
//       <div className="flex flex-col h-[89vh] justify-between !bg-white !bg-opacity-90 border-r overflow-y-auto border-darkborder hide-scroll">
//         <div className="flex flex-col">
//           <List className="flex flex-col">
//             <Link
//               to={"/dashboard"}
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/dashboard"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <RxDashboard className="!text-xl" /> Dashboard
//             </Link>

//             <Link
//               to={"/store/vendor-list"}
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/store/vendor-list"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <BiLogoPlayStore className="!text-xl" />{" "}
//               {superuserId === "true" ? "Active (Store/vendor)" : " My Store"}
//             </Link>
//             <Link
//               onClick={handleClick4}
//               to="/enventory-management"
//               className={classNames(
//                 "p-2 px-2 flex manul-color text-sm !py-3 justify-between my-0 w-full",
//                 window.location.pathname === "/enventory-management"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <LuSettings className="!text-xl" />
//                 Inventory
//               </span>

//               {open4 ? <ExpandMore /> : <NavigateNextIcon />}
//             </Link>

//             <Collapse
//               in={open4}
//               timeout="auto"
//               className="flex flex-col w-11/12 mx-1 border rounded-lg"
//               unmountOnExit
//             >
//               <List className="!flex !flex-col !py-0 gap-2">
//                 <Link
//                   to={"/enventory-management/add-product"}
//                   className={classNames(
//                     "p-2 manul-color text-sm w-full",
//                     window.location.pathname ===
//                       "/enventory-management/add-product"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                 >
//                   Products
//                 </Link>

//                 <Link
//                   to={"/add-product-variant"}
//                   className={classNames(
//                     "p-2 manul-color text-sm w-full",
//                     window.location.pathname === "/add-product-variant"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                 >
//                   Product Variants
//                 </Link>
//                 <Link
//                   to={"/specification-types"}
//                   className={classNames(
//                     "p-2 manul-color text-sm w-full",
//                     window.location.pathname === "/specification-types"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                 >
//                   Specification Types
//                 </Link>
//                 <Link
//                   onClick={() => setOpen5(!open5)}
//                   to={"/variant-mangement"}
//                   className={classNames(
//                     "flex p-2 manul-color text-sm justify-between w-full",
//                     window.location.pathname === "/variant-mangement"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                 >
//                   Variant Management
//                   {open5 ? <ExpandMore /> : <NavigateNextIcon />}
//                 </Link>
//                 <Collapse
//                   in={open5}
//                   timeout="auto"
//                   className="flex mx-1 flex-col w-11/12 mb-2 ml-[7.5px] border rounded-lg"
//                   unmountOnExit
//                 >
//                   <List className="!flex !flex-col !py-0 gap-2">
//                     <Link
//                       to={"/variant-mangement-color"}
//                       className={classNames(
//                         "p-2  manul-color text-sm relative w-full",
//                         window.location.pathname === "/variant-mangement-color"
//                           ? "w-full hover-color rounded"
//                           : "",
//                       )}
//                     >
//                       Manage Color Variant (Type One)
//                     </Link>

//                     <Link
//                       to={"/variant-mangement-storage"}
//                       className={classNames(
//                         "p-2  manul-color text-sm relative w-full",
//                         window.location.pathname ===
//                           "/variant-mangement-storage"
//                           ? "w-full hover-color rounded"
//                           : "",
//                       )}
//                     >
//                       Manage Storage Variant (Type Two)
//                     </Link>

//                     <Link
//                       to={"/variant-management-other"}
//                       className={classNames(
//                         "p-2 manul-color text-sm relative w-full",
//                         window.location.pathname === "/variant-management-other"
//                           ? "w-full hover-color rounded"
//                           : "",
//                       )}
//                     >
//                       Manage Other Variant (Type Three)
//                     </Link>
//                     <Link
//                       to={"/variant-management-connectivity"}
//                       className={classNames(
//                         "p-2 manul-color text-sm relative w-full",
//                         window.location.pathname ===
//                           "/variant-management-connectivity"
//                           ? "w-full hover-color rounded"
//                           : "",
//                       )}
//                     >
//                       Manage Connectivity Variant (Type Four)
//                     </Link>
//                     <Link
//                       to={"/variant-management-screensize"}
//                       className={classNames(
//                         "p-2 manul-color text-sm relative w-full",
//                         window.location.pathname ===
//                           "/variant-management-screensize"
//                           ? "w-full hover-color rounded"
//                           : "",
//                       )}
//                     >
//                       Manage ScreenSize Variant (Type Five)
//                     </Link>
//                   </List>
//                 </Collapse>
//               </List>
//             </Collapse>

//             <Link
//               to="/order-management"
//               className={classNames(
//                 "p-2 px-2 flex flex-row gap-2 manul-color text-sm !py-3 my-0 w-full",
//                 window.location.pathname === "/order-management"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <MdProductionQuantityLimits className="!text-xl" /> Orders
//               Management
//             </Link>
//             {/* <Link
//               onClick={handleClick8}
//               to="/order-management"
//               className={classNames(
//                 "p-2 px-2 flex manul-color text-sm !py-3 justify-between px-2 my-0 w-full",
//                 window.location.pathname === "/order-management"
//                   ? "w-full hover-color rounded-lg"
//                   : ""
//               )}
//             >
//              <span className="flex gap-x-2"><MdProductionQuantityLimits className="!text-xl"/> Orders</span>
//               {open8 ? <ExpandMore /> : <NavigateNextIcon />}
//             </Link> */}
//             {/* <Collapse
//               in={open8}
//               timeout="auto"
//               className="flex flex-col w-56 mx-1 border rounded-lg"
//               unmountOnExit
//             >
//               <List className="!flex !flex-col !py-0">
//                 <Link
//                   to={"/order-management/customer-order"}
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-full",
//                     window.location.pathname ===
//                       "/order-management/customer-order"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                 >
//                   Customer Order
//                 </Link>
//                 <Link
//                   to={"/return"}
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-full",
//                     window.location.pathname === "/return"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                 >
//                   Return & Refund
//                 </Link>
//                 <Link
//                   to={"/replace"}
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-full",
//                     window.location.pathname === "/replace"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                 >
//                   Replacement
//                 </Link>
//               </List>
//             </Collapse> */}
//             <Link
//               onClick={handleClick1}
//               to={"/manage-store"}
//               className={classNames(
//                 "p-2 px-2 flex manul-color text-sm !py-3 justify-between px-2 my-0 w-full",
//                 window.location.pathname === "/manage-store"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <LuSettings className="!text-xl" /> Business Data
//               </span>
//               {open1 ? <ExpandMore /> : <NavigateNextIcon />}
//             </Link>
//             <Collapse
//               in={open1}
//               className="flex flex-col w-11/12 mx-1 border rounded-lg"
//               timeout="auto"
//               unmountOnExit
//             >
//               <List className="!flex !flex-col !py-0">
//                 {superuserId === "true" ? (
//                   <Link
//                     to={"/business-category"}
//                     className={classNames(
//                       "p-2 manul-color text-sm  m-2 w-full",
//                       window.location.pathname === "/business-category"
//                         ? "w-full hover-color rounded"
//                         : "",
//                     )}
//                   >
//                     Business Type
//                   </Link>
//                 ) : null}
//                 {superuserId === "true" ? (
//                   <Link
//                     to={"/manage-store/business-sub-type"}
//                     className={classNames(
//                       "p-2 manul-color text-sm  m-2 w-full",
//                       window.location.pathname ===
//                         "/manage-store/business-sub-type"
//                         ? "w-full hover-color rounded"
//                         : "",
//                     )}
//                   >
//                     Business Sub Type
//                   </Link>
//                 ) : null}

//                 <Link
//                   // onClick={handleClick1}
//                   to={"/manage-product"}
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-full",
//                     window.location.pathname === "/manage-product"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                 >
//                   Category
//                 </Link>
//                 <Link
//                   to={"/product-sub-category"}
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-full",
//                     window.location.pathname === "/product-sub-category"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                 >
//                   Sub Category
//                 </Link>
//                 <Link
//                   to={"/product-brand"}
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-full",
//                     window.location.pathname === "/product-brand"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                 >
//                   Brand
//                 </Link>
//               </List>
//             </Collapse>

//             {/* wallet management start */}
//             {/* <Link
//               onClick={handleClick3}
//               to={"/manage-wallet"}
//               className={classNames(
//                 "p-2 px-2 flex manul-color text-sm !py-3 justify-between px-2 my-0 w-56",
//                 window.location.pathname === "/manage-wallet"
//                   ? "w-full hover-color rounded-lg"
//                   : ""
//               )}
//             >
//               <span className="flex gap-x-2"><GiWallet className="!text-xl"/> Wallet Management</span>
//               {open3 ? <ExpandMore /> : <NavigateNextIcon />}
//             </Link>

//             <Collapse
//               in={open3}
//               className="flex flex-col w-56 mx-1 border rounded-lg"
//               timeout="auto"
//               unmountOnExit
//             >
//               <List className="!flex !flex-col !py-0">
//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-full",
//                     window.location.pathname === "/my-wallet"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                   to={"/my-wallet"}
//                 >
//                   My Wallet
//                 </Link>
//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-full",
//                     window.location.pathname ===
//                       "/manage-wallet/available-wallet"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                   to={"/manage-wallet/available-wallet"}
//                 >
//                   Available Vendor Wallet
//                 </Link>

//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-full",
//                     window.location.pathname ===
//                       "/manage-wallet/wallet-transition"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                   to={"/manage-wallet/wallet-transition"}
//                 >
//                   Wallet Transition
//                 </Link>
//               </List>
//             </Collapse> */}
//             {/* wallet management end */}

//             {/* Customization Header management start */}
//             <Link
//               onClick={handleClick11}
//               to={"/customization"}
//               className={classNames(
//                 "p-2 flex manul-color text-sm !py-3 justify-between my-0 w-full",
//                 window.location.pathname === "/customization"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex items-center gap-2">
//                 <LuSettings className="!text-xl" />
//                 Customization Header
//               </span>
//               <span className=""></span>
//               {open11 ? <ExpandMore /> : <NavigateNextIcon />}
//             </Link>

//             <Collapse
//               in={open11}
//               className="flex flex-col w-11/12 mx-1 border rounded-lg"
//               timeout="auto"
//               unmountOnExit
//             >
//               <List className="!flex !flex-col !py-0">
//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-48",
//                     window.location.pathname === "/customization/header"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                   to={"/customization/header"}
//                 >
//                   Header
//                 </Link>
//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-48",
//                     window.location.pathname === "/customization/main-header"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                   to={"/customization/main-header"}
//                 >
//                   Main Header
//                 </Link>

//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-48",
//                     window.location.pathname === "/customization/sub-header"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                   to={"/customization/sub-header"}
//                 >
//                   Sub Header
//                 </Link>
//               </List>
//             </Collapse>
//             {/* Customization Header management end */}

//             {/* Product Specification management start */}
//             {/* <Link
//               onClick={handleClick12}
//               to={"/product-specification"}
//               className={classNames(
//                 "p-2 px-2 flex manul-color text-sm !py-3 justify-between px-2 my-0 w-56",
//                 window.location.pathname === "/product-specification"
//                   ? "w-full hover-color rounded-lg"
//                   : ""
//               )}
//             >
//               <span className="flex gap-x-2"><LuSettings className=" !text-xl"/>Product Specification</span>
//               {open12 ? <ExpandMore /> : <NavigateNextIcon />}
//             </Link>

//             <Collapse
//               in={open12}
//               className="flex flex-col w-56 mx-1 border rounded-lg"
//               timeout="auto"
//               unmountOnExit
//             >
//               <List className="!flex !flex-col !py-0">
//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-48",
//                     window.location.pathname === "/product-specification/specification"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                   to={"/product-specification/specification"}
//                 >
//                   Specification
//                 </Link>
//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-48",
//                     window.location.pathname ===
//                       "/product-specification/specification-type"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                   to={"/product-specification/specification-type"}
//                 >
//                   Specification Type
//                 </Link>

//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-48",
//                     window.location.pathname ===
//                       "/product-specification/specification-value"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                   to={"/product-specification/specification-value"}
//                 >
//                   Specification Value
//                 </Link>
//               </List>
//             </Collapse> */}
//             {/* Product Specification management end */}

//             <Link
//               to={"/customer-list"}
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/customer-list"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <BiSolidUserCircle className="mt-0 !text-xl" />
//                 Customer
//               </span>
//             </Link>

//             <Link
//               to={"/rating-review"}
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/rating-review"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <StarBorderIcon className="mt-0 !text-xl  text-yellow-500" />
//                 Rating Review Management
//               </span>
//             </Link>

//             <Link
//               to={"/page-design"}
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/page-design"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <StarBorderIcon className="mt-0 !text-xl  text-yellow-500" />
//                 Page Design
//               </span>
//             </Link>

//             {/* <Link
//                 to={"/invoice"}
//                 className={classNames(
//                   "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                   window.location.pathname === "/invoice"
//                     ? "w-full hover-color rounded-lg"
//                     : ""
//                 )}
//               >

//                 <span className="flex gap-x-2"><FaFileInvoiceDollar className="mt-[1px]"/>Invoice</span>

//               </Link> */}

//             {superuserId === true ? (
//               <Link
//                 to={"/reset-password"}
//                 className={classNames(
//                   "p-2 px-2 manul-color text-sm  m-2 w-full",
//                   window.location.pathname === "/reset-password"
//                     ? "w-full hover-color rounded"
//                     : "",
//                 )}
//               >
//                 Reset Password
//               </Link>
//             ) : null}

//             <Link
//               to="/banner"
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/banner"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <LuSettings className="mt-0 !text-xl" /> Banner Management
//               </span>
//             </Link>

//             {/* custom notofication start */}
//             {/* <Link
//               to="/custom-notofication"
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/custom-notofication"
//                   ? "w-full hover-color rounded-lg"
//                   : ""
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <IoNotificationsCircleOutline className="mt-0 !text-2xl" />{" "}
//                 Custom Notification
//               </span>
//             </Link> */}
//             {/* Contacts Access */}
//             <Link
//               to="/contact-access"
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/contact-access"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <Phone className="mt-0 !text-2xl" /> Contacts Access
//               </span>
//             </Link>
//             {/* custom notofication start */}
//             {/* delivery Management start */}
//             <Link
//               to="/delivery"
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/delivery"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <TbTruckDelivery className="mt-0 text-xl" />
//                 Delivery Management
//               </span>
//             </Link>
//             {/* delivery Management end */}

//             {/* delivery pincode start */}
//             <Link
//               to="/delivery-pincode"
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/delivery-pincode"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <TbMapPinCode className="mt-0 text-xl" />
//                 Delivery Pincode
//               </span>
//             </Link>
//             {/* delivery pincode end */}
//             {/* /delivery-pincode */}

//             {/* configration start */}
//             {/* <Link
//               onClick={handleClick9}
//               to={"/configration"}
//               className={classNames(
//                 "p-2 px-2 flex manul-color text-sm !py-3 justify-between px-2 my-0 w-full",
//                 window.location.pathname === "/configration"
//                   ? "w-full hover-color rounded-lg"
//                   : ""
//               )}
//             >
//               <span className="flex gap-x-2"><LuSettings className="!text-xl"/>Configuration</span>
//               {open9 ? <ExpandMore /> : <NavigateNextIcon />}

//             </Link>
//             <Collapse
//               in={open9}
//               className="flex flex-col w-56 mx-1 border rounded-lg"
//               timeout="auto"
//               unmountOnExit
//             >
//               <List className="!flex !flex-col !py-0">
//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-48",
//                     window.location.pathname === "/configration/email"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                   to={"/configration/email"}
//                 >
//                   Email Configration
//                 </Link>

//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-48",
//                     window.location.pathname === "/sms"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                   to={"/sms"}
//                 >
//                   SMS Configration
//                 </Link>
//                 <Link
//                   className={classNames(
//                     "p-2 manul-color text-sm  m-2 w-48",
//                     window.location.pathname === "/whatsapp"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                   to={"/whatsapp"}
//                 >
//                   Whatsapp Configration
//                 </Link>
//               </List>
//             </Collapse> */}
//             {/* configration end */}

//             {/* deduction amount start */}
//             {/* <Link
//               to={"/wallet-diduction"}
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/wallet-diduction"
//                   ? "w-full hover-color rounded-lg"
//                   : ""
//               )}
//             >

//               <span className="flex gap-x-2"><GiWallet className="!text-xl"/>Deduction Amount</span>
//             </Link> */}
//             {/* deduction amount end */}

//             {/*  */}

//             {superuserId === "true" ? (
//               <div>
//                 <Link
//                   onClick={handleClick6}
//                   to={"/store"}
//                   className={classNames(
//                     "p-2 px-2 flex manul-color text-sm  justify-between m-2 w-full",
//                     window.location.pathname === "/store"
//                       ? "w-full hover-color rounded"
//                       : "",
//                   )}
//                 >
//                   Pending For Approval
//                   {open6 ? <ExpandMore /> : <NavigateNextIcon />}
//                 </Link>

//                 <Collapse in={open6} timeout="auto" unmountOnExit>
//                   <List className="!flex !flex-col !py-0">
//                     {superuserId === "true" ? (
//                       <Link
//                         to={"/pending/approval"}
//                         className={classNames(
//                           "p-2 manul-color text-sm m-2 w-full ml-5",
//                           window.location.pathname === "/pending/approval"
//                             ? "w-full hover-color rounded"
//                             : "",
//                         )}
//                       >
//                         <span className="text-sm">Pending Store Approval</span>
//                       </Link>
//                     ) : null}
//                     {superuserId === "true" ? (
//                       <Link
//                         to={"/store/product/pending"}
//                         className={classNames(
//                           "p-2 manul-color text-sm m-2 w-full ml-5",
//                           window.location.pathname === "/store/product/pending"
//                             ? "w-full hover-color rounded"
//                             : "",
//                         )}
//                       >
//                         Pending Product Variant
//                       </Link>
//                     ) : null}
//                     <Link
//                       to={"/product-approval"}
//                       className={classNames(
//                         "p-2 manul-color text-sm m-2 w-full ml-5",
//                         window.location.pathname === "/product-approval"
//                           ? "w-full hover-color rounded"
//                           : "",
//                       )}
//                     >
//                       Pending Product Approval
//                     </Link>
//                   </List>
//                 </Collapse>
//               </div>
//             ) : null}

//             <Link
//               to="/slider"
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/slider"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <LuSettings className="!text-xl" /> Slider Management
//               </span>
//             </Link>

//             {/* enquery management start */}
//             <Link
//               to="/enquiry"
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/enquiry"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <LuSettings className="!text-xl" />
//                 Enquiry Management
//               </span>
//             </Link>
//             {/* enquery management end */}

//             {/* firebase sync management start */}
//             <Link
//               to="/cod-management"
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/cod-management"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <LuSettings className="!text-xl" />
//                 Cash On Delivery Management
//               </span>
//             </Link>

//             <Link
//               to="/fire"
//               className={classNames(
//                 "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//                 window.location.pathname === "/fire"
//                   ? "w-full hover-color rounded-lg"
//                   : "",
//               )}
//             >
//               <span className="flex gap-x-2">
//                 <LuSettings className="!text-xl" />
//                 Firebase Sync Setting
//               </span>
//             </Link>
//             {/* firebase sync management end */}

//             {/* plan management start */}
//             {/* {superuserId === "true" ? (
//               <div>
//                 <Link
//                   onClick={handleClick7}
//                   to="/plans"
//                   className={classNames(
//                     "p-2 px-2 flex manul-color text-sm  justify-between m-2 w-full",
//                     window.location.pathname === "/plans"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                 >
//                   Subscription Plans
//                   {open7 ? <ExpandMore /> : <NavigateNextIcon />}
//                 </Link>

//                 <Collapse in={open7} timeout="auto" unmountOnExit>
//                   <List className="!flex !flex-col !py-0">
//                     {superuserId === "true" ? (
//                       <Link
//                         to={"/plans/vendor-subscription-plan"}
//                         className={classNames(
//                           "p-2 manul-color text-sm m-2 w-full ml-5",
//                           window.location.pathname ===
//                             "/plans/vendor-subscription-plan"
//                             ? "w-full hover-color rounded"
//                             : ""
//                         )}
//                       >
//                         <span className="text-sm">
//                           Vendor Subscription Plans
//                         </span>
//                       </Link>
//                     ) : null}

//                     <Link
//                       to={"/plans/vendor-point-simulators"}
//                       className={classNames(
//                         "p-2 manul-color text-sm m-2 w-full ml-5",
//                         window.location.pathname ===
//                           "/plans/vendor-point-simulators"
//                           ? "w-full hover-color rounded"
//                           : ""
//                       )}
//                     >
//                       Vendor Points Stimulators
//                     </Link>
//                   </List>
//                 </Collapse>
//               </div>
//             ) : null} */}
//             {/* plan management end */}
//           </List>
//           <Link
//             to="/offer"
//             className={classNames(
//               "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//               window.location.pathname === "/offer"
//                 ? "w-full hover-color rounded-lg"
//                 : "",
//             )}
//           >
//             <span className="flex gap-x-2">
//               <LuSettings className="!text-xl" />
//               Offer Management
//             </span>
//           </Link>

//           {/* testimonial management start */}
//           <Link
//             to="/testimonials"
//             className={classNames(
//               "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//               window.location.pathname === "/testimonials"
//                 ? "w-full hover-color rounded-lg"
//                 : "",
//             )}
//           >
//             <span className="flex gap-x-2">
//               <LuSettings className="!text-xl" />
//               Testimoniol
//             </span>
//           </Link>

//           <Link
//             to="/addsence"
//             className={classNames(
//               "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//               window.location.pathname === "/addsence"
//                 ? "w-full hover-color rounded-lg"
//                 : "",
//             )}
//           >
//             <span className="flex gap-x-2">
//               <LuSettings className="!text-xl" />
//               AdSense Setting
//             </span>
//           </Link>

//           <Link
//             to="/facebookpixel"
//             className={classNames(
//               "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//               window.location.pathname === "/facebookpixel"
//                 ? "w-full hover-color rounded-lg"
//                 : "",
//             )}
//           >
//             <span className="flex gap-x-2">
//               <LuSettings className="!text-xl" />
//               Facebook Pixel Setting
//             </span>
//           </Link>

//           <Link
//             to="/terms&condition"
//             className={classNames(
//               "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//               window.location.pathname === "/terms&condition"
//                 ? "w-full hover-color rounded-lg"
//                 : "",
//             )}
//           >
//             <span className="flex gap-x-2">
//               <LuSettings className="!text-xl" />
//               Terms And Conditions Management
//             </span>
//           </Link>
//           <Link
//             to="/privacy&policy"
//             className={classNames(
//               "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//               window.location.pathname === "/privacy&policy"
//                 ? "w-full hover-color rounded-lg"
//                 : "",
//             )}
//           >
//             <span className="flex gap-x-2">
//               <LuSettings className="!text-xl" />
//               Privacy & Policy
//             </span>
//           </Link>

//           <Link
//             to="/return&replacement"
//             className={classNames(
//               "p-2 flex gap-x-2 manul-color text-sm !py-3 px-2 my-0 w-full",
//               window.location.pathname === "/return&replacement"
//                 ? "w-full hover-color rounded-lg"
//                 : "",
//             )}
//           >
//             <span className="flex gap-x-2">
//               <LuSettings className="!text-xl" />
//               Return Refund And Replacement Management
//             </span>
//           </Link>

//           {/* testimonial management end */}

//           {/* payment management start */}
//           {/* <Link
//               onClick={handleClick10}
//               to={"/payment"}
//               className={classNames(
//                 "p-2 px-2 flex manul-color text-sm !py-3 justify-between px-2 my-0 w-full",
//                 window.location.pathname === "/payment"
//                   ? "w-full hover-color rounded-lg"
//                   : ""
//               )}
//             >

//               <span className="flex gap-x-2"><MdPayment className="mt-0 !text-xl"/>Payment Gateway</span>
//               {open10 ? <ExpandMore /> : <NavigateNextIcon />}
//             </Link> */}
//           {/* payment management end */}

//           {/* <Collapse
//               in={open10}
//               className="flex flex-col w-56 mx-1 border rounded-lg"
//               timeout="auto"
//               unmountOnExit
//             >
//               <List className="!flex !flex-col !py-0">
//                 <Link
//                   to={"/payment/available-payment"}
//                   className={classNames(
//                     "p-2 px-3 m-2 manul-color text-sm w-full pl-5",
//                     window.location.pathname === "/payment/available-payment"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                 >
//                   Available Payment
//                 </Link>

//                 <Link
//                   className={classNames(
//                     "p-2 px-3 m-2 manul-color text-sm w-full pl-5",
//                     window.location.pathname === "/payment/razor"
//                       ? "w-full hover-color rounded"
//                       : ""
//                   )}
//                   to={"/payment/razor"}
//                 >
//                   Setup Credential
//                 </Link>
//               </List>
//             </Collapse> */}
//           {superuserId === "true" ? (
//             <Link
//               to={"/store-data-mapping"}
//               className={classNames(
//                 "p-2 manul-color text-sm m-2 w-full ml-5",
//                 window.location.pathname === "/store-data-mapping"
//                   ? "w-full hover-color rounded"
//                   : "",
//               )}
//             >
//               <span className="text-sm">Store Data Mapping</span>
//             </Link>
//           ) : null}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Sidebar;

import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { Phone } from "@mui/icons-material";
import { Collapse } from "@mui/material";
import "./side.css";
import { RxDashboard } from "react-icons/rx";
import { BiLogoPlayStore, BiSolidUserCircle } from "react-icons/bi";
import { MdProductionQuantityLimits } from "react-icons/md";
import { LuSettings } from "react-icons/lu";
import { TbTruckDelivery, TbMapPinCode } from "react-icons/tb";

const Sidebar = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState({});
  const toggle = (key) => setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  const superuserId = localStorage.getItem("is_superuser");
  const isSuper = superuserId === "true";

  const menu = [
    {
      key: "dashboard",
      label: "Dashboard",
      to: "/dashboard",
      icon: RxDashboard,
    },
    {
      key: "store",
      label: isSuper ? "Active (Store/vendor)" : "My Store",
      to: "/store/vendor-list",
      icon: BiLogoPlayStore,
    },
    {
      key: "inventory",
      label: "Inventory",
      to: "/enventory-management",
      icon: LuSettings,
      children: [
        {
          key: "products",
          label: "Products",
          to: "/enventory-management/add-product",
        },
        {
          key: "variants-list",
          label: "Product Variants",
          to: "/add-product-variant",
        },
        {
          key: "spec-types",
          label: "Specification Types",
          to: "/specification-types",
        },
        {
          key: "variant-mgmt",
          label: "Variant Management",
          to: "/variant-mangement",
          children: [
            {
              key: "v-color",
              label: "Manage Color Variant (Type One)",
              to: "/variant-mangement-color",
            },
            {
              key: "v-storage",
              label: "Manage Storage Variant (Type Two)",
              to: "/variant-mangement-storage",
            },
            {
              key: "v-other",
              label: "Manage Other Variant (Type Three)",
              to: "/variant-management-other",
            },
            {
              key: "v-conn",
              label: "Manage Connectivity Variant (Type Four)",
              to: "/variant-management-connectivity",
            },
            {
              key: "v-screen",
              label: "Manage ScreenSize Variant (Type Five)",
              to: "/variant-management-screensize",
            },
          ],
        },
      ],
    },
    {
      key: "orders",
      label: "Orders Management",
      to: "/order-management",
      icon: MdProductionQuantityLimits,
    },
    {
      key: "business",
      label: "Business Data",
      to: "/manage-store",
      icon: LuSettings,
      children: [
        {
          key: "b-type",
          label: "Business Type",
          to: "/business-category",
          hide: !isSuper,
        },
        {
          key: "b-subtype",
          label: "Business Sub Type",
          to: "/manage-store/business-sub-type",
          hide: !isSuper,
        },
        { key: "b-cat", label: "Category", to: "/manage-product" },
        { key: "b-subcat", label: "Sub Category", to: "/product-sub-category" },
        { key: "b-brand", label: "Brand", to: "/product-brand" },
      ],
    },
    {
      key: "customization",
      label: "Customization Header",
      to: "/customization",
      icon: LuSettings,
      children: [
        { key: "c-header", label: "Header", to: "/customization/header" },
        {
          key: "c-main",
          label: "Main Header",
          to: "/customization/main-header",
        },
        { key: "c-sub", label: "Sub Header", to: "/customization/sub-header" },
      ],
    },
    {
      key: "customer",
      label: "Customer",
      to: "/customer-list",
      icon: BiSolidUserCircle,
    },
    {
      key: "rating",
      label: "Rating Review Management",
      to: "/rating-review",
      icon: StarBorderIcon,
    },
    {
      key: "page-design",
      label: "Page Design",
      to: "/page-design",
      icon: StarBorderIcon,
    },
    // kept exactly as in your original (strict boolean check, so it never shows)
    {
      key: "reset",
      label: "Reset Password",
      to: "/reset-password",
      hide: superuserId !== true,
    },
    {
      key: "banner",
      label: "Banner Management",
      to: "/banner",
      icon: LuSettings,
    },
    {
      key: "contacts",
      label: "Contacts Access",
      to: "/contact-access",
      icon: Phone,
    },
    {
      key: "delivery",
      label: "Delivery Management",
      to: "/delivery",
      icon: TbTruckDelivery,
    },
    {
      key: "pincode",
      label: "Delivery Pincode",
      to: "/delivery-pincode",
      icon: TbMapPinCode,
    },
    {
      key: "pending",
      label: "Pending For Approval",
      to: "/store",
      hide: !isSuper,
      children: [
        {
          key: "p-store",
          label: "Pending Store Approval",
          to: "/pending/approval",
          hide: !isSuper,
        },
        {
          key: "p-variant",
          label: "Pending Product Variant",
          to: "/store/product/pending",
          hide: !isSuper,
        },
        {
          key: "p-product",
          label: "Pending Product Approval",
          to: "/product-approval",
        },
      ],
    },
    {
      key: "slider",
      label: "Slider Management",
      to: "/slider",
      icon: LuSettings,
    },
    {
      key: "enquiry",
      label: "Enquiry Management",
      to: "/enquiry",
      icon: LuSettings,
    },
    {
      key: "cod",
      label: "Cash On Delivery Management",
      to: "/cod-management",
      icon: LuSettings,
    },
    {
      key: "fire",
      label: "Firebase Sync Setting",
      to: "/fire",
      icon: LuSettings,
    },
    { key: "offer", label: "Offer Management", to: "/offer", icon: LuSettings },
    {
      key: "testimonial",
      label: "Testimoniol",
      to: "/testimonials",
      icon: LuSettings,
    },
    {
      key: "adsense",
      label: "AdSense Setting",
      to: "/addsence",
      icon: LuSettings,
    },
    {
      key: "pixel",
      label: "Facebook Pixel Setting",
      to: "/facebookpixel",
      icon: LuSettings,
    },
    {
      key: "terms",
      label: "Terms And Conditions Management",
      to: "/terms&condition",
      icon: LuSettings,
    },
    {
      key: "privacy",
      label: "Privacy & Policy",
      to: "/privacy&policy",
      icon: LuSettings,
    },
    {
      key: "return",
      label: "Return Refund And Replacement Management",
      to: "/return&replacement",
      icon: LuSettings,
    },
    {
      key: "mapping",
      label: "Store Data Mapping",
      to: "/store-data-mapping",
      hide: !isSuper,
    },
  ];

  const renderItem = (item, level = 0) => {
    if (item.hide) return null;

    const Icon = item.icon;
    const hasChildren = Boolean(item.children);
    const isOpen = Boolean(open[item.key]);
    const isActive = pathname === item.to;

    return (
      <div key={item.key}>
        <Link
          to={item.to}
          onClick={hasChildren ? () => toggle(item.key) : undefined}
          className={classNames(
            "manul-color flex w-full items-center justify-between gap-1.5 rounded-md leading-tight",
            level === 0 ? "px-2 py-1.5 text-xs" : "px-2 py-1 text-[11px]",
            isActive && "hover-color",
          )}
        >
          <span className="flex min-w-0 items-center gap-1.5">
            {Icon && <Icon className="shrink-0 !text-sm" />}
            <span>{item.label}</span>
          </span>
          {hasChildren &&
            (isOpen ? (
              <ExpandMore sx={{ fontSize: 16 }} />
            ) : (
              <NavigateNextIcon sx={{ fontSize: 16 }} />
            ))}
        </Link>

        {hasChildren && (
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <div className="ml-3 mt-0.5 flex flex-col gap-px border-l border-slate-200 pl-1">
              {item.children.map((child) => renderItem(child, level + 1))}
            </div>
          </Collapse>
        )}
      </div>
    );
  };

  return (
    <nav className="hide-scroll flex h-full w-full flex-col gap-px overflow-y-auto bg-white p-1.5">
      {menu.map((item) => renderItem(item))}
    </nav>
  );
};

export default Sidebar;
